import jwtInterceptor from '/src/shared/jwtInterceptor'


const apiUrl= process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const state = () => ({
  messageCount:0,
  activeOrderCount:0
});

const actions = {
  async getStates()
  {
    const url = apiUrl + 'app/getState';
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data.states
    }
  },
  async getMessageCount({commit})
  {
    const url = apiUrl + 'getMessageCount';
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      commit('saveMessageCount',response.data.count);
      return response.data.count
    }
    commit('saveMessageCount',0);
    return 0;
  },
  async getActiveOrderCount({commit})
  {
    const url = apiUrl + 'getActiveOrderCount';
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      commit('saveActiveOrderCount',response.data.count);
      return response.data.count
    }
    commit('saveActiveOrderCount',0);
    return 0;
  },
  async getWarehouseTotalBuyPrice()
  {
    const url = apiUrl + 'app/getWarehouseTotalBuyPrice';
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getRegisterCode(c,phone)
  {
    const url = apiUrl + 'app/getRegisterCode?phone='+phone;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async submitRegisterCode(c,{code,phone})
  {
    const url = apiUrl + 'app/submitRegisterCode?phone='+phone+'&code='+code;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async getPlans()
  {
    const url = apiUrl + 'plans/get';
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data.plans
    }
    return []
  },
  async getJobs()
  {
    const url = apiUrl + 'job/list?number=100';
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data.jobs;
    }
  },
  async getCities(chert,stateId)
  {
    console.log(stateId)
    const url = apiUrl + 'app/getCity?state_id='+stateId;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getProductVariableAttr(c,id)
  {
    const url = apiUrl + 'getProduct/Attributes?id='+id;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data.attr;
    }
  },
  async sendResetCodeFunc(c,phone)
  {
    const url = apiUrl + 'sendResetCodeForPassword?phone='+phone;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async submitResetCodeFunc(c,{phone,code,password,re_password})
  {
    const url = apiUrl + 'user/submitResetPassword?code='+code+'&password='+password+'&re_password='+re_password+'&phone='+phone;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async getNewServiceRequest(chert,id)
  {
    const url = apiUrl + 'newServiceRequest/get?id='+id;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getNewProductRequest(chert,id)
  {
    const url = apiUrl + 'newProductRequest/get?id='+id;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getServicesOfAuto()
  {
    const url = apiUrl + 'AppServices/get';
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getGroupOfService(c,service_id)
  {
    const url = apiUrl + 'getGroupOfService?service_id='+service_id;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async submitServiceForAutoService(c,items)
  {
    const url = apiUrl + 'submitServiceForAutoService';
    var response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getAutoServiceService(c,id)
  {
    const url = apiUrl + 'getAutoServiceService?id='+id;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async editAutoServiceService(c,items)
  {
    const url = apiUrl + 'editAutoServiceService';
    var response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async AutoServiceServiceDelete(c,id)
  {
    const url = apiUrl + 'AutoServiceServiceDelete?id='+id;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getProductForPricing()
  {
    const url = apiUrl + 'getProductForPricing';
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getAutoWastage(c,id)
  {
    const url = apiUrl + 'AutoWastage/get?id='+id;
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getAllAutoWastage()
  {
    const url = apiUrl + 'AutoWastage/getAll';
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async submitWastageSellRequest(c,items)
  {
    const url = apiUrl + 'WastageSellRequest/submit';
    var response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getWastageSellReqForEdit(c,id)
  {
    const url = apiUrl + 'WastageSellReq/get?id='+id;
    var response = await jwtInterceptor.get(url);
    console.log(response)
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async editWastageSellRequest(c,items)
  {
    const url = apiUrl + 'WastageSellRequest/edit';
    var response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async GetServiceCategories(c,id)
  {
    let url = apiUrl + 'GetServiceCategories';
    if (id)
      url += '?parent_id='+id;
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getWastageSellInvoice(c,id)
  {
    let url = apiUrl + 'WastageSellInvoice/get?id='+id;
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getIncomeReportItems()
  {
    let url = apiUrl + 'IncomeReportItems/get';
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getCustomerReportItems(c,id)
  {
    let url = apiUrl + 'customer/ReportItems/Get?id='+id;
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getAdminReportItems(c,id)
  {
    let url = apiUrl + 'admin/ReportItems/Get?id='+id;
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async checkScanOrderQrCode(c,token)
  {
    let url = apiUrl + 'checkScanOrderQrCode/'+token;
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getAutoServiceServices()
  {
    let url = apiUrl + 'getAutoServiceServices';
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async addNewCatalog(c,items)
  {
    let url = apiUrl + 'addNewCatalog';
    var response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async getCatalogInfo(c,id)
  {
    let url = apiUrl + 'Catalog/getInfo/'+id;
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async editCatalogInfo(c,items)
  {
    let url = apiUrl + 'Catalog/editInfo/'+items.id;
    var response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
    return false;
  },
  async sendVisitorLocation(c,items)
  {
    try
    {
      let url = apiUrl + 'sendVisitorLocation';
      await jwtInterceptor.post(url,items);
    }
    catch (e)
    {
      //
    }
  }


};

const mutations = {
  saveMessageCount(state,c)
  {
    state.messageCount = c;
  },
  saveActiveOrderCount(state,c)
  {
    state.activeOrderCount = c;
  }
}

const getters = {
  getMessageCount(state)
  {
    return state.messageCount
  },
  getActiveOrderCount(state)
  {
    return state.activeOrderCount
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}